export default {"src":"/_next/static/media/ousg-light.b160142e.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};